import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment-timezone";
import React, { Component } from "react";
import DeleteDialog from "../../components/DeleteDialog";
import DeletePlayersDialog from "../../components/teams/DeletePlayersDialog";
import MoveTeamDialog from "../../components/teams/MoveTeamDialog";
import NoTeamsMessage from "../../components/teams/NoTeamsMessage";
import TeamsTable from "../../components/teams/TeamsTable";
import { languages } from "../../constants/languages";
import { exportPlayers } from "./ExportPlayersContainer";

class TeamsTableContainer extends Component {
  state = {
    teams: [],
    teamsLoaded: false,
    order: "asc",
    orderBy: "name",
    selected: [],
    open: false,
    moveDialogOpen: false,
    deleteButtonDisabled: false,
    moveButtonDisabled: false,
    oneSecondPassed: false,
    orderedQuestion: false,
    deletePlayersDialogOpen: false,
    // days: [],
    // daysByKey: {},
    // daysLoaded: false,
    sportParks: [],
    sportParksByKey: {},
    sportParksLoaded: false,
    allTeams: [],
    allTeamsByKey: {},
    allTeamsLoaded: false,
  };

  UNSAFE_componentWillMount = () => {
    this.timeout = setTimeout(() => {
      this.setState({ oneSecondPassed: true });
    }, 1000);
    if (this.props.refereesPage) {
      this.unsubscribe = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("referees")
        .onSnapshot((querySnapshot) => {
          var teams = [];
          querySnapshot.forEach(function (doc) {
            let team = doc.data();
            team["id"] = doc.id;
            if (team.createdAt) {
              team["added"] = moment(team.createdAt.toDate()).unix();
            }
            teams.push(team);
          });
          let sortedTeams = this.sortTeams(
            teams,
            this.state.order,
            this.state.orderBy
          );
          this.setState({
            teams: sortedTeams,
            teamsLoaded: true,
          });
        });
      // this.unsubscribeDays = window.firebase
      //   .firestore()
      //   .collection("tournaments")
      //   .doc(this.props.tournament[".key"])
      //   .collection("days")
      //   .onSnapshot(querySnapshot => {
      //     let days = [];
      //     let daysObj = {};
      //     querySnapshot.forEach(doc => {
      //       let day = doc.data();
      //       day["id"] = doc.id;
      //       days.push(day);
      //       daysObj[doc.id] = doc.data();
      //     });
      //     this.setState({
      //       days: days.sort((a, b) => a.date - b.date),
      //       daysByKey: daysObj,
      //       daysLoaded: true
      //     });
      //   });

      this.unsubscribeSportparks = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("sportParks")
        .onSnapshot((querySnapshot) => {
          let sportParks = [];
          let sportParksObj = {};
          querySnapshot.forEach((doc) => {
            let sportPark = doc.data();
            sportPark["id"] = doc.id;
            sportParks.push(sportPark);
            sportParksObj[doc.id] = sportPark;
          });
          let sportParksSorted = sportParks.sort((a, b) => {
            if (a.num > b.num) {
              return 1;
            } else if (a.num < b.num) {
              return -1;
            }
            if (a.id > b.id) {
              return 1;
            } else if (a.id < b.id) {
              return -1;
            } else {
              return 0;
            }
          });
          let newState = {
            sportParks: sportParksSorted,
            sportParksByKey: sportParksObj,
            sportParksLoaded: true,
          };

          this.setState(newState);
        });

      // TODO: Fix so teams aren't loaded twice
      this.unsubscribeTeams = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("teams")
        .onSnapshot((querySnapshot) => {
          var teams = [];
          let teamsByKey = {};
          querySnapshot.forEach(function (doc) {
            let team = doc.data();
            team["id"] = doc.id;
            if (team.createdAt) {
              team["added"] = moment(team.createdAt.toDate()).unix();
            }
            teams.push(team);
            teamsByKey[doc.id] = team;
          });

          teams.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            } else {
              return 1;
            }
          });
          this.setState({
            allTeams: teams,
            allTeamsByKey: teamsByKey,
            allTeamsLoaded: true,
          });
        });
    } else if (this.props.adminsPage) {
      const tournamentRef = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);

      this.unsubscribe = tournamentRef
        .collection("admins")
        .onSnapshot((querySnapshot) => {
          let admins = [];
          let adminsByKey = {};
          querySnapshot.forEach(function (doc) {
            let admin = doc.data();
            admin["id"] = doc.id;
            admins.push(admin);
            adminsByKey[doc.id] = admin;
          });

          this.setState({
            teams: admins,
            teamsLoaded: true,
          });
        });
    } else {
      this.unsubscribe = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("teams")
        .where("division", "==", this.props.division.id)
        .onSnapshot((querySnapshot) => {
          var teams = [];
          querySnapshot.forEach(function (doc) {
            let team = doc.data();
            team["id"] = doc.id;
            if (team.createdAt) {
              team["added"] = moment(team.createdAt.toDate()).unix();
            }
            teams.push(team);
          });
          let sortedTeams = this.sortTeams(
            teams,
            this.state.order,
            this.state.orderBy,
            this.state.orderedQuestion
          );
          this.setState({
            teams: sortedTeams,
            teamsLoaded: true,
          });
        });
    }
  };

  componentWillUnmount = () => {
    // unsubscribe
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    clearTimeout(this.timeout);
    // if (this.unsubscribeDays) {
    //   this.unsubscribeDays();
    // }
    if (this.unsubscribeSportparks) {
      this.unsubscribeSportparks();
    }
    if (this.unsubscribeTeams) {
      this.unsubscribeTeams();
    }
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open, errorMessage: "" });
  };

  toggleMoveDialog = () => {
    this.setState({
      moveDialogOpen: !this.state.moveDialogOpen,
      errorMessage: "",
    });
  };

  toggleDeletePlayersDialog = () => {
    this.setState({
      deletePlayersDialogOpen: !this.state.deletePlayersDialogOpen,
    });
  };

  sortTeams = (teams, order, orderBy, question = false, product = false) => {
    let data = teams.sort((a, b) => {
      function chunkify(t) {
        var tz = [],
          x = 0,
          y = -1,
          n = 0,
          i,
          j;

        while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
          // eslint-disable-next-line
          var m = i == 46 || (i >= 48 && i <= 57);
          if (m !== n) {
            tz[++y] = "";
            n = m;
          }
          tz[y] += j;
        }
        return tz;
      }

      let toChunkA = a[orderBy] || "";
      let toChunkB = b[orderBy] || "";

      if (question) {
        toChunkA = (a["questions"] || {})[orderBy] || "";
        toChunkB = (b["questions"] || {})[orderBy] || "";
      }

      if (product) {
        toChunkA = (a["products"] || {})[orderBy] || "";
        toChunkB = (b["products"] || {})[orderBy] || "";
      }

      var aa = chunkify(toChunkA.toString().toLowerCase());
      var bb = chunkify(toChunkB.toString().toLowerCase());

      for (let x = 0; aa[x] && bb[x]; x++) {
        if (aa[x] !== bb[x]) {
          var c = Number(aa[x]),
            d = Number(bb[x]);
          // eslint-disable-next-line
          if (c == aa[x] && d == bb[x]) {
            return c - d;
          } else return aa[x] > bb[x] ? 1 : -1;
        }
      }
      return aa.length - bb.length;
    });
    if (order === "desc") {
      return data.reverse();
    } else {
      return data;
    }
  };

  handleRequestSort = (event, property, question = false, product = false) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    let data = this.sortTeams(
      this.state.teams,
      order,
      orderBy,
      question,
      product
    );

    this.setState({ order, orderBy, teams: data, orderedQuestion: question });
  };

  handleSelectAllClick = (event, checked) => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      if (checked) {
        this.setState({ selected: this.state.teams });
        return;
      }
      this.setState({ selected: [] });
    }
  };

  handleClick = (event, team) => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      const { selected } = this.state;
      let selectedIndex = -1;
      for (let i = 0; i < selected.length; i++) {
        if (team.id === selected[i].id) {
          selectedIndex = i;
          break;
        }
      }
      let newSelected = [];

      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, team);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }

      this.setState({ selected: newSelected });
    }
  };

  handleMoveSelected = (divisionId) => {
    this.setState({ moveButtonDisabled: true });
    const db = window.firebase.firestore();
    const teamsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teams");
    let batch = db.batch();

    for (let i = 0; i < this.state.selected.length; i++) {
      const toUpdate = { division: divisionId };
      const team = this.state.selected[i];
      for (let x = 0; x < 10; x++) {
        if (team["poule" + x.toString()]) {
          toUpdate["poule" + x.toString()] = null;
        }
      }
      batch.update(teamsRef.doc(team.id), toUpdate);
    }
    batch.commit().then(() => {
      this.setState({ moveButtonDisabled: false, selected: [] });
      this.toggleMoveDialog();
    });
  };

  deleteReferee = (refereeId) => {
    const db = window.firebase.firestore();
    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");

    matchesRef.get().then((querySnapshot) => {
      let batch2 = db.batch();
      batch2.delete(
        db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("referees")
          .doc(refereeId)
      );

      querySnapshot.forEach((doc) => {
        if (doc.data().referee === refereeId) {
          batch2.update(matchesRef.doc(doc.id), { referee: null });
        }
        if (doc.data().referee2 === refereeId) {
          batch2.update(matchesRef.doc(doc.id), { referee2: null });
        }
        if (doc.data().referee3 === refereeId) {
          batch2.update(matchesRef.doc(doc.id), { referee3: null });
        }
        if (doc.data().referee4 === refereeId) {
          batch2.update(matchesRef.doc(doc.id), { referee4: null });
        }
        if (doc.data().referee5 === refereeId) {
          batch2.update(matchesRef.doc(doc.id), { referee5: null });
        }
      });
      if (this.props.tournament.ia) {
        batch2.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }
      batch2.commit();
    });
  };

  handleDeleteSelected = () => {
    this.setState({ deleteButtonDisabled: true });
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    var i, j;
    for (i = 0, j = this.state.selected.length; i < j; i += 200) {
      let temparray = this.state.selected.slice(i, i + 200);
      let batch = db.batch();
      let admins = this.props.tournament.admins || [];

      for (let t = 0; t < temparray.length; t++) {
        const team = temparray[t];
        if (this.props.refereesPage) {
          this.deleteReferee(team.id);
        } else if (this.props.adminsPage) {
          batch.delete(tournamentRef.collection("admins").doc(team.id));

          admins.splice(admins.indexOf(team.id), 1);
          batch.update(tournamentRef, { admins: admins });
        } else {
          batch.delete(tournamentRef.collection("teams").doc(team.id));
          if (this.props.tournament.teamsAsRefs) {
            this.deleteReferee(team.id);
          }
        }
        if (!this.props.refereesPage && !this.props.adminsPage) {
          batch.set(
            tournamentRef.collection("teamsDeleted").doc(team.id),
            team
          );
        }
      }
      batch.commit();
    }
    this.setState({ deleteButtonDisabled: false, selected: [] });
    this.toggleDialog();
  };

  handleToPlayersClick = (e, toPlayers) => {
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    tournamentRef.update({ individualPlayers: toPlayers });
  };

  handleDeletePlayers = async (selectedTeams) => {
    try {
      const db = window.firebase.firestore();
      const tournamentRef = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);

      // Process each team sequentially to avoid batch size limits
      for (const team of selectedTeams) {
        // Get all players for this team
        const playersSnapshot = await tournamentRef
          .collection("players")
          .where("team", "==", team.id)
          .get();

        // Create a batch for this team's players
        let batch = db.batch();
        playersSnapshot.forEach((doc) => {
          batch.delete(doc.ref);
        });

        // Commit the batch for this team
        await batch.commit();
      }

      // Clear selection after successful deletion
      this.setState({ selected: [] });
    } catch (error) {
      console.error("Error deleting players:", error);
      // You might want to show an error message to the user here
    }
  };

  handleExportPlayers = () => {
    exportPlayers(this.props.tournament, this.props.divisionsObject);
    this.setState({ exportMenuAnchorEl: null });
  };

  render() {
    let teams = this.state.teams;
    teams = teams.map((team) => {
      let teamCopy = team;
      if (this.props.contactInfoLoaded) {
        teamCopy["email"] =
          (this.props.teamsContactInfo[team.id] || {}).email || "";
        // teamCopy["language"] =
        //   (this.props.teamsContactInfo[team.id] || {}).language || "";
        teamCopy["questions"] =
          (this.props.teamsContactInfo[team.id] || {}).questions || {};
        Object.keys(this.props.tournament.infoFields || {}).forEach((key) => {
          if ((this.props.teamsContactInfo[team.id] || {})[key] !== undefined) {
            teamCopy[key] = (this.props.teamsContactInfo[team.id] || {})[key];
          }
        });
      }
      return teamCopy;
    });

    let loaded = true;
    if (this.props.refereesPage) {
      loaded =
        this.state.sportParksLoaded &&
        this.props.daysLoaded &&
        this.state.allTeamsLoaded;
    }
    return (
      <div>
        <DeleteDialog
          open={this.state.open}
          handleDelete={this.handleDeleteSelected}
          toggleDialog={this.toggleDialog}
          deleteButtonDisabled={this.state.deleteButtonDisabled}
          title={
            this.props.refereesPage
              ? languages.referees.deleteReferees
              : this.props.adminsPage
              ? languages.admins.deleteAdmins
              : languages.formatString(
                  languages.teams.deleteTeams,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )
          }
          description={
            this.props.refereesPage
              ? languages.referees.deleteWarning2
              : this.props.adminsPage
              ? languages.admins.deleteWarning2
              : languages.formatString(
                  languages.teams.deleteWarning,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )
          }
        />
        <DeletePlayersDialog
          open={this.state.deletePlayersDialogOpen}
          handleClose={this.toggleDeletePlayersDialog}
          handleConfirm={() => {
            this.handleDeletePlayers(this.state.selected);
            this.toggleDeletePlayersDialog();
          }}
          selectedTeams={this.state.selected}
        />
        {!this.props.refereesPage && !this.props.adminsPage && (
          <MoveTeamDialog
            moveDialogOpen={this.state.moveDialogOpen}
            handleMoveSelected={this.handleMoveSelected}
            toggleMoveDialog={this.toggleMoveDialog}
            moveButtonDisabled={this.state.moveButtonDisabled}
            divisions={this.props.divisions}
            division={this.props.division}
            tournament={this.props.tournament}
          />
        )}
        {this.state.teamsLoaded && loaded ? (
          teams.length === 0 ? (
            <div style={{ paddingTop: 10 }}>
              {this.props.dropdown}
              <NoTeamsMessage
                tournament={this.props.tournament}
                division={this.props.division}
                divisions={this.props.divisions}
                refereesPage={this.props.refereesPage}
                adminsPage={this.props.adminsPage}
                handleToPlayersClick={this.handleToPlayersClick}
                sportParks={this.state.sportParks}
                days={this.props.days}
                allTeams={this.state.allTeams}
                allTeamsByKey={this.state.allTeamsByKey}
                teams={[]}
              />
            </div>
          ) : (
            <TeamsTable
              tournament={this.props.tournament}
              teams={teams}
              order={this.state.order}
              orderBy={this.state.orderBy}
              handleRequestSort={this.handleRequestSort}
              division={this.props.division}
              selected={this.state.selected}
              handleSelectAllClick={this.handleSelectAllClick}
              handleClick={this.handleClick}
              toggleDialog={this.toggleDialog}
              toggleMoveDialog={this.toggleMoveDialog}
              toggleDeletePlayersDialog={this.toggleDeletePlayersDialog}
              divisions={this.props.divisions}
              tournamentStatus={this.props.tournamentStatus}
              toggleFinishedDialog={this.props.toggleFinishedDialog}
              dropdown={this.props.dropdown}
              refereesPage={this.props.refereesPage}
              adminsPage={this.props.adminsPage}
              user={this.props.user}
              sportParks={this.state.sportParks}
              days={this.props.days}
              allTeams={this.state.allTeams}
              allTeamsByKey={this.state.allTeamsByKey}
              teamsContactInfo={this.props.teamsContactInfo}
              contactInfoLoaded={this.props.contactInfoLoaded}
              playersContactInfo={this.props.playersContactInfo}
              playersContactInfoLoaded={this.props.playersContactInfoLoaded}
              divisionsObject={this.props.divisionsObject}
              onDeletePlayers={this.handleDeletePlayers}
              handleExportPlayers={this.handleExportPlayers}
            />
          )
        ) : (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              paddingTop: 20,
              height: 177,
            }}
          >
            {this.state.oneSecondPassed && <CircularProgress />}
          </div>
        )}
      </div>
    );
  }
}

export default TeamsTableContainer;
